/*
 * Click tracking for the "צפיה בשילוב" buttons on bundle 2.0 listings.
 *
 * The buttons themselves are rendered by snippets/product-card.liquid; this
 * only reports the click. One delegated listener covers every card, including
 * ones added later by pagination or by the live-updating search results.
 *
 * Ported from the Variant experience exp-EXP6D7BE5A7. The original cancelled
 * the click, started a 2s fallback timer, fired the events, cleared the timer
 * and then navigated anyway - which left no time for anything to be sent. The
 * link is left alone here instead, so navigation is never delayed.
 */
(function () {
  'use strict';

  var EXPERIMENT_ID = 'EXP6D7BE5A7';
  var VARIATION_ID = '1';

  function track(eventName, extra) {
    try {
      if (typeof Variant === 'undefined' || !Variant.publishCustomEvent) return;
      var payload = { experiment_id: EXPERIMENT_ID, variation_id: VARIATION_ID };
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
      }
      Variant.publishCustomEvent(eventName, payload);
    } catch (e) {
      /* never break the page for analytics */
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-combo-button]');
      if (!button) return;

      var handle = button.getAttribute('data-product-handle') || '';
      track('product-clicked-attribution', { product_id: handle });
      track('influenced-revenue', { source: 'view_combo_button', product_handle: handle });
    },
    true
  );
})();
